<template>
  <div class="notification-group">
    <transition-group name="fade" tag="div">
      <notification
        v-for="item in getNotifications"
        :id="item.id"
        :key="item.id"
        class="notification"
        :class="[item.type]"
      />
    </transition-group>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Notification from './Notification.vue';

export default {
  components: {
    notification: Notification,
  },

  computed: {
    ...mapGetters('application/notifications', ['getNotifications']),
  },
};
</script>

<style scoped lang="scss">
.notification-group {
  position: fixed;
  bottom: 20px;
  z-index: 999;
  transform: translateX(-50%);
  left: 50%;
  width: 500px;
}

.fade-enter-active {
  transition: all 0.5s ease;
}

.fade-leave-active {
  position: absolute;
  width: 100%;
  bottom: 0;
}

.fade-enter,
.fade-leave-to {
  // transform: translateY(100%);
  opacity: 0;
  transition: all 0.5s;
}

.fade-move {
  transition: all 0.5s;
}
</style>
